var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"rigthTop"}},[_c('div',{staticClass:"lb-title"},[_vm._v("运营事件")]),_c('div',{staticStyle:{"width":"100%","height":"50%"},attrs:{"id":"offline"}}),_c('div',{staticStyle:{"width":"100%","height":"50%"},attrs:{"id":"typeline"}})])
}]

export { render, staticRenderFns }